module.exports = __webpack_public_path__ + "assets/img/Compact.616b5603.svg";